/* --------------------------------------------------------------------------
   Aanbevolen producten

   Shopify berekent aanbevelingen op verkoopdata, en levert ze alleen via een
   eigen aanvraag — niet bij het gewone renderen van de pagina. Daarom haalt dit
   script de sectie na het laden opnieuw op en zet de uitkomst op zijn plek.

   Wat er ondertussen staat, is de collectie die in de sectie is gekozen. Komt
   er niets terug — nieuwe winkel, te weinig verkoopdata, of een product zonder
   verwanten — dan blijft die staan. De bezoeker ziet dus nooit een gat.

   Zonder JavaScript gebeurt er niets en blijft diezelfde collectie staan.
   -------------------------------------------------------------------------- */
(function () {
  var houders = document.querySelectorAll('[data-recommendations][data-url]');
  if (!houders.length) return;

  houders.forEach(function (houder) {
    var url = houder.dataset.url;
    if (!url) return;

    fetch(url)
      .then(function (antwoord) {
        if (!antwoord.ok) throw new Error('Aanbevelingen niet opgehaald');
        return antwoord.text();
      })
      .then(function (tekst) {
        var doos = document.createElement('div');
        doos.innerHTML = tekst;

        var verse = doos.querySelector('[data-recommendations]');
        if (!verse) return;

        /*
          Alleen vervangen als er werkelijk iets in zit. Een leeg antwoord zou
          anders de collectie weghalen die er als terugval staat.
        */
        if (verse.innerHTML.trim().length === 0) return;

        houder.innerHTML = verse.innerHTML;
      })
      .catch(function () {
        /* Stil falen: wat er staat blijft staan. */
      });
  });
})();
